/** 연간시간표·연간진도표 화면에서는 숨겨진 keep-alive(프로그램) 탐색 단축키를 받지 않는다 */
export function isAppBrowseNavigationShortcutBlockedRoute(pathname: string): boolean {
  return (
    pathname === '/annual-timetable' ||
    pathname === '/annual-progress-term1' ||
    pathname === '/annual-progress-term2'
  );
}

/**
 * Shift+G / Shift+F / Shift+H / Shift+U / Shift+I 등 앱 단축키: 입력 중이면 처리하지 않음.
 * (한글 IME 조합 중에는 e.code 로도 맞출 수 있으나, 조합 문자가 입력 필드로 들어가는 것은 막기 위해 isComposing 도 본다.)
 */
export function shouldIgnoreAppNavigationShortcut(e: KeyboardEvent): boolean {
  if (e.isComposing) return true;
  const t = e.target;
  if (!t || !(t instanceof Element)) return false;
  if (t.closest('input, textarea, select, [contenteditable="true"]')) return true;
  return false;
}
